module.exports = __webpack_public_path__ + "static/media/level3-3.ae30ffd2.mp3";